import { UntypedFormGroup } from '@angular/forms';
import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-bottom-form-navigation',
  templateUrl: './bottom-form-navigation.component.html',
  styleUrls: ['./bottom-form-navigation.component.scss']
})

export class BottomFormNavigationComponent {
  @Input() resourceForm: UntypedFormGroup = null;
  @Input() resourceIdList: number[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  private navigateTo(id: number): void {
    this.router.navigate(['..', id], { relativeTo: this.route, queryParamsHandling: 'merge' });
  }

  public position(): number {
    return this.resourceIdList.indexOf(+this.resourceForm?.get('id').value) + 1;
  }

  public next(event: Event): void {
    const actualId = +this.resourceForm?.get('id').value;
    const nextId = this.resourceIdList[this.resourceIdList.indexOf(actualId) + 1];

    if (nextId) {
      this.navigateTo(nextId);
    }
  }

  public previous(event: Event): void {
    const actualId = +this.resourceForm?.get('id').value;
    const previousId = this.resourceIdList[this.resourceIdList.indexOf(actualId) - 1];

    if (previousId) {
      this.navigateTo(previousId);
    }
  }
}

